import { collapsesChartIndex } from './chartUtils'
import { pruneMetricsForCollection } from './collectionMetrics'
import { DEFAULT_CHART_AXIS } from './constants'
import {
  conditionsToFilters,
  filterbyToFilters,
  filtersToConditions,
  filtersToFilterby,
} from './filterEntities'

function resolveConfigurationFilters(configuration) {
  if (Array.isArray(configuration.filters)) return configuration.filters

  return [
    ...filterbyToFilters(configuration.filterby || {}),
    ...conditionsToFilters(configuration.conditions || []),
  ]
}

export function buildReportViewConfiguration({ config, charts, pinned = false }) {
  return {
    collection: config.collection,
    groupby: config.groupby || [],
    metrics: config.metrics || [],
    sortby: config.sortby || [],
    filters: config.filters || [],
    filterby: filtersToFilterby(config.filters || []),
    conditions: filtersToConditions(config.filters || []),
    charts: charts || [],
    pinned,
  }
}

export function isReportPinned(configuration) {
  return Boolean(configuration?.pinned)
}

function withDefaultChartAxis(chart) {
  if (collapsesChartIndex(chart?.dataType)) return chart
  if (chart?.dimensions?.length) return chart

  return { ...chart, dimensions: [DEFAULT_CHART_AXIS] }
}

export function applyReportViewConfiguration(configuration, dates, setConfig, setCharts) {
  if (!configuration) return

  setConfig(prev => ({
    ...prev,
    collection: configuration.collection || prev.collection,
    groupby: [...configuration.groupby || []],
    metrics: pruneMetricsForCollection(
      configuration.metrics || [],
      configuration.collection || prev.collection,
    ),
    sortby: [...configuration.sortby || []],
    filters: [...resolveConfigurationFilters(configuration)],
    startDate: dates?.startDate ?? prev.startDate,
    endDate: dates?.endDate ?? prev.endDate,
  }))
  setCharts((configuration.charts || []).map(withDefaultChartAxis))
}
